module.exports = __webpack_public_path__ + "img/snippet-cx-previews.fc968a8c.png";